import {Box} from "@mui/material";

export default function CardFooter(props) {
  return (
    <Box sx={{backgroundColor: "cardFooterColor.main"}} py={2} px={{xs: 2, md: 5}}>
      {props.children}
    </Box>
  )
}